'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    mapService: 'WMS',
    imageFormat: 'PNG',
    mapLayerPosition: 'BASEMAP'
};
//# sourceMappingURL=externalMapLayer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/model/config/model-defaults/externalMapLayer.js
// module id = 593
// module chunks = 13